import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
// formatters
import { FormattedDate } from 'react-intl';
import { DateStyles } from '../../constants/CentricConstants';
// structure
import AutoComplete from '../Common/AutoComplete';
import { Card, CardActions, CardHeader, CardText } from 'material-ui/Card';
import AssetSegmentAdmin from '../Asset/AssetSegmentAdmin';
import CourseLabelSegment from "./CourseLabelSegment";
import CourseModuleTable from './CourseModuleTable.react';
import DetailView from '../Common/DetailView';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import { Form } from 'formsy-react';
import LinearProgress from 'material-ui/LinearProgress';
import MenuItem from 'material-ui/MenuItem';
import SelectModule from '../Module/SelectModule';
// icons
import IconButton from 'material-ui/IconButton';
import EditIcon from 'material-ui/svg-icons/editor/mode-edit';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import InfoIcon from 'material-ui/svg-icons/action/info';
import EnrolmentIcon from 'material-ui/svg-icons/action/check-circle';
import TimeLineIcon from 'material-ui/svg-icons/action/timeline';
import IconList from 'material-ui/svg-icons/action/subject';
import SchoolIcon from 'material-ui/svg-icons/social/school';
import UpIcon from 'material-ui/svg-icons/navigation/arrow-upward';
// constants
import ROLES from '../../constants/Roles';
// business logic
import AssetActions from '../../actions/AssetActionCreator';
import AssetStore from '../../stores/AssetStore';
import CourseActions from '../../actions/CourseActionCreator';
import CourseStore from '../../stores/CourseStore';
import CourseModuleStore from '../../stores/CourseModuleStore';
import CourseAssetStore from '../../stores/CourseAssetStore';
import LabelActions from "../../actions/LabelActionCreator";
import LabelStore from "../../stores/LabelStore";

import { statusColours } from '../../constants/ColourConstants';

import buildContextMenu from '../Common/BuildContextMenu';
import { withId } from '../Common/Decorators';
import CourseEnrolmentStatStore from '../../stores/CourseEnrolmentStatStore';

let timeout; // for autocomplete

const iconProps = {
    color: statusColours.default,
};

const getActions = (row, canEdit, onDelete) => [
    {
        link: `/dashboard/course/${row.id}`,
        icon: <InfoIcon />,
        label: 'Preview',
    },
    {
        type:'divider'
    },
    {
        link: `/dashboard/course/${row.id}/enrolments`,
        icon: <EnrolmentIcon />,
        label: 'Enrolments',
        condition: {
            roles: [ROLES.MANAGER]
        }
    },
    {
        link: `/dashboard/module/${row.designatedModuleId}/activity`,
        icon: <TimeLineIcon />,
        label: 'Activity',
        condition: {
            roles: [ROLES.MANAGER, ROLES.ADMIN],
            show: !!row.designatedModuleId
        }
    },
    {
        type: 'divider'
    },
    {
        link: `/dashboard/course/${row.id}/edit`,
        icon: <EditIcon />,
        label: 'Edit',
        condition: {
            show: canEdit,
            roles: [ROLES.ADMIN]
        }
    },
    {
        type: 'deleteDialog',
        dialogType: 'menu',
        value: row.id,
        title: 'Delete ',
        deleteAction: onDelete,
        message: (<span>Are you sure you want to delete this course?</span>),
        condition: {
            show: canEdit,
            roles: [ROLES.ADMIN]
        }
    }
];

const CourseSettings = React.createClass({

    getInitialState: function(){

        return {
            dialog: {
                open: '',
                value: null,
            },
            details: {
                name: '',
                description: '',
                theme: '',
                image: '',
                overview: '',
                duration: '',
                cost: '',
                price: '',
                url: '',
                courseSurveyUrl: '',
                type: '',
                status: '',
                code: '',
                capacity: '',
                version: '',
                visibility: '',
                validFrom: '',
                validTo: '',
                skillId: '',
                skillName: '',
                skillCode: '',
                sendEmail: '',
                emailTemplate: '',
                categoryId: '',
                category: '',
                designatedModuleId: null,
                labels: []
            },
            enrolmentCount: 0,
            designateLoad: false,
            modules: [],
            moduleList: [],
            moduleData: [],
            assets: [],
            assetList: [],
            labelList: [],
            actions: [],
            links: {
                back: `/dashboard/course/${this.props.id}`,
                list: '/dashboard/courses',
                edit: '',
            }
        }
    },

    componentWillMount: function() {
        this.setState({actions: buildContextMenu(getActions({id: this.props.routeParams}, false, this._onDelete), this.context.auth)});
        this._onCourseChange();
        this._onCourseModuleChange();
        this._onCourseAssetChange();
    },

    componentDidMount: function(){
        this.listeners = [
            CourseStore.addListener(this._onCourseChange),
            CourseModuleStore.addListener(this._onCourseModuleChange),
            CourseAssetStore.addListener(this._onCourseAssetChange),
            AssetStore.addListener(this._onAssetChange),
            CourseEnrolmentStatStore.addListener(this.onEnrolmentChange),
            LabelStore.addListener(this.onLabelChange)
        ];

        CourseActions.getById(this.props.id);
        CourseActions.getAssets(this.props.id);
        CourseActions.getModules(this.props.id);
        LabelActions.getAll();
    },

    componentWillUnmount: function() {
        this.listeners.forEach(listener => listener.remove());
        CourseAssetStore.removeChangeListener(this._onCourseAssetChange);
    },

    getDialog() {
        if (!this.state.dialog.open) { return null; }
        switch (this.state.dialog.open) {
            case 'addModule':
                const { enrolmentCount } = this.state;
                return (
                    <Dialog
                        open={true}
                        title="Add module"
                        actions={[
                            <FlatButton key="cancel" label="Cancel" onTouchTap={this.closeDialog} />,
                            <FlatButton
                                key="submit"
                                label="Save"
                                onTouchTap={this.dialogSave}
                                disabled={!this.state.dialog.value || CourseEnrolmentStatStore.isFetching()}
                                primary={true}
                            />,
                        ]}
                        onRequestClose={this.closeDialog}
                    >
                        {(enrolmentCount > 0) && (
                            <div>Please Note:
                                You are adding a Module to a Course with {enrolmentCount} existing {enrolmentCount > 1 ? 'Enrolments' : 'Enrolment'}.
                                {enrolmentCount > 1 ? 'These existing Enrolments' : 'This existing Enrolment'} will not include this new Module.
                                You may manually Enrol {enrolmentCount > 1 ? 'those users' : 'the user'} to this Module.</div>
                        )}
                        <SelectModule
                            label="Find module"
                            clearOnSelect={false}
                            onSelect={(name, id) => this.onDialogSelect({name, id})}
                            onUpdate={() => this.onDialogSelect(null)}
                        />
                    </Dialog>
                );

            case 'addAsset':
                return (
                    <Dialog
                        open={true}
                        title="Add asset"
                        actions={[
                            <FlatButton key="cancel" label="Cancel" onTouchTap={this.closeDialog} />,
                            <FlatButton key="submit" label="Save" onTouchTap={this.dialogSave} disabled={this.state.dialog.value === null} primary={true} />,
                        ]}
                        onRequestClose={this.closeDialog}
                    >
                        <AutoComplete
                            floatingLabelText="Asset"
                            maxSearchResults={5}
                            dataSource={this.state.assetList}
                            onUpdateInput={this._onAssetAutocomplete}
                        />
                    </Dialog>
                );

            case 'addLabel':
                return (
                    <Dialog
                        open
                        title="Add label"
                        actions={[
                            <FlatButton key="cancel" label="Cancel" onTouchTap={this.closeDialog} />,
                            <FlatButton key="submit" label="Save" onTouchTap={this.dialogSave} disabled={this.state.dialog.value === null} primary />,
                        ]}
                        onRequestClose={this.closeDialog}
                    >
                        <AutoComplete
                            floatingLabelText="Label"
                            maxSearchResults={5}
                            dataSource={this.state.labelList}
                        />
                    </Dialog>
                );

            case 'cannotAdd':
                return (
                    <Dialog
                        open={true}
                        title="Add module"
                        modal={false}
                        onRequestClose={this.closeDialog}
                        actions={[<FlatButton key="cancel" label="ok" onTouchTap={this.closeDialog} />]}
                    >
                        Cannot add when a module has been embedded. To add, first release embedded module.
                    </Dialog>
                );

            case 'removeModule':
                return (
                    <Dialog
                        open
                        title="Remove module"
                        modal={false}
                        onRequestClose={this.closeDialog}
                        actions={[
                            <FlatButton key="cancel" label="Cancel" onTouchTap={this.closeDialog} />,
                            <FlatButton key="submit" label="Remove" onTouchTap={this.dialogSave} disabled={this.state.dialog.value === null} primary={true} />
                        ]}
                    >
                        Are you sure you wish to remove this module?
                    </Dialog>
                );


            default:
                return null;
        }
    },

    render: function(){
        const dialog = this.getDialog();

        let emailTemplate;
        if (this.state.details.sendEmail !== '') {
            emailTemplate = (!!this.state.details.sendEmail ? (this.state.details.emailTemplate || 'Default') : 'No emails sent');
        }

        let moduleActions = [
            <FlatButton
                key="addModule"
                label="Add"
                onTouchTap={() => !this.state.details.designatedModuleId ? this.openAddModuleDialog() : this._openDialog('cannotAdd')}
            />,
            <FlatButton
                key="update"
                type="submit"
                label="Update"
                disabled={!this.state.modules || this.state.modules.length <= 0}
                primary={true} />
        ];
        if (!!this.state.details.designatedModuleId) {
            moduleActions.push(
                <FlatButton label="Release" onTouchTap={this.releaseModule} key="release" />
            );
        } else if (this.state.modules.length === 1) {
            moduleActions.push(
                <FlatButton label="Embed" onTouchTap={() => this.designateModule(this.state.modules[0].id)} key="designate" primary={true} />
            );
        }

        return (

            <DetailView
                title={this.state.details.name}
                backButton={true}
                backTo={this.state.links.back}
                actions={this.state.actions}
                showFormMessages={true}
            >
                <div className="cent-cards">
                    <Card className="cent-card">
                        <CardHeader
                            title='Settings'
                            subtitle='general course settings'
                            avatar={(<SchoolIcon {...iconProps} />)}
                        />
                        <CardText className="cent-card-text">
                            <div className='cent-flex-row'>
                                <div className='cent-col-2'>
                                    <ul className="cent-list-plain">
                                        <li><em>Code: </em>{this.state.details.code}</li>
                                        <li><em>Version: </em>{this.state.details.version}</li>
                                        <li><em>Type: </em>{this.state.details.type}</li>
                                        <li>
                                            <em>Category: </em>
                                            <Link to={`/dashboard/library/${this.state.details.categoryId || 'uncategorised'}`}>
                                                {this.state.details.category || 'Uncategorised'}
                                            </Link>
                                        </li>
                                        <li><em>Visibility: </em>{this.state.details.visibility}</li>
                                        <li><em>Scope: </em>{(!!this.state.details.accessGroup) ? this.state.details.accessGroup : ''}</li>
                                        <li><em>Available from: </em>{!!this.state.details.validFrom && (
                                            <FormattedDate value={this.state.details.validFrom} {...DateStyles.long} />)}</li>
                                        <li><em>Available to: </em>{!!this.state.details.validTo && (<FormattedDate value={this.state.details.validTo} {...DateStyles.long} />)}</li>
                                        <li><em>Status: </em>{this.state.details.status}</li>
                                    </ul>
                                </div>
                                <div className='cent-col-2'>
                                    <ul className="cent-list-plain">
                                        <li><em>Duration: </em>{this.state.details.duration}</li>
                                        <li><em>Capacity: </em>{this.state.details.capacity}</li>
                                        <li>
                                            <em>Skill: </em>
                                            <Link to={`/dashboard/skill/${this.state.details.skillId || ''}`}>
                                                {this.state.details.skillName || ''}
                                            </Link>
                                        </li>
                                        <li><em>Email template: </em>{emailTemplate}</li>
                                        <li>
                                            <em>Vendor: </em>
                                            <Link to={`/dashboard/vendor/${this.state.details.vendorId}`}>
                                                {this.state.details.vendor || ''}
                                            </Link>
                                        </li>
                                        <li><em>Cost: </em>{this.state.details.cost}</li>
                                        <li><em>Price: </em>{this.state.details.price}</li>
                                        <li><em>URL: </em>{this.state.details.url}</li>
                                        <li><em>Course Survey URL: </em>{this.state.details.courseSurveyUrl}</li>

                                    </ul>
                                </div>
                            </div>
                        </CardText>
                    </Card>

                    <Form
                        ref="form"
                        className="form"
                        onValidSubmit={this._onSave}
                    >
                        <Card className="cent-card">
                            <CardHeader
                                title='Outline'
                                subtitle='manage modules for this course'
                                avatar={(<IconList {...iconProps} />)}
                            />
                                <CourseModuleTable
                                    data={this.state.modules}
                                    actions={this.getModuleActions}
                                    infoLink="/dashboard/module/{id}/settings"
                                    onModuleChange={this.updateModuleData}
                                />
                                {!!this.state.designateLoad && <LinearProgress />}
                            <CardActions>
                                {moduleActions}
                            </CardActions>
                        </Card>
                    </Form>

                    <AssetSegmentAdmin
                        assets={this.state.assets}
                        addAction={this._openAddAssetDialog}
                        deleteAction={(assetId) => CourseActions.removeAsset(this.props.routeParams.id, assetId)}
                    />

                    <CourseLabelSegment
                        labels={this.state.details.labels}
                        addAction={() => this._openDialog('addLabel')}
                        deleteAction={(labelId) => CourseActions.removeLabel(this.props.routeParams.id, labelId)}
                    />

                </div>
               {dialog}
            </DetailView>
        );
    },

    onEnrolmentChange() {
        const enrolmentStats = CourseEnrolmentStatStore.getCourseStats(this.props.id);
        const enrolmentCount = enrolmentStats.reduce((st, {enrolments}) => st + enrolments, 0);
        this.setState({enrolmentCount});
    },

    _onCourseChange: function(){
        const course = CourseStore.getById(this.props.id);
        if (course !== undefined) {
            const canEdit = this.context.auth.canEdit(course.access);
            const actions = buildContextMenu(getActions(course, canEdit, this._onDelete), this.context.auth);
            this.setState({details: course, actions, designateLoad: false});
        }
    },

    _onCourseModuleChange: function() {
        const modules = CourseModuleStore.getModules(Number(this.props.id));
        if (modules !== undefined){
            this.setState({
                modules,
                moduleData: modules.map(({id, mandatory, requirement}) => ({ moduleId: id, mandatory, requirement }))
            });
        }
    },

    getModuleActions: function(module) {
        if (module.id === this.state.details.designatedModuleId) { return []; }

        let actions = [
            <IconButton onTouchTap={() => this.setState({dialog: {open: 'removeModule', value: module.id}})}>
                <DeleteIcon />
            </IconButton>
        ];

        if (module.listOrder !== 1) {
            actions.push(
                <IconButton onTouchTap={() => CourseActions.moveModuleUp(this.props.id, module.id)}>
                    <UpIcon/>
                </IconButton>
            );
        }

        return actions;
    },

    addModule: function(module) {
        if (!module) { return false; }
        const index = this.state.modules.findIndex((e) => !!e && e.id === module.id);
        if (0 > index) {
            const modules = [
                ...this.state.modules,
                {
                    ...module,
                    loading: true,
                    mandatory: true,
                }
            ];
            this.setState({modules: modules});
            CourseActions.addModule(this.props.id, module.id);
        }

        return true;
    },

    updateModuleData: function (data) {
        this.setState({
            moduleData: [
                ...this.state.moduleData.filter(({moduleId}) => moduleId !== data.moduleId),
                {
                    ...this.state.moduleData.find((module) => module.moduleId === data.moduleId),
                    ...data
                }
            ]
        })
    },

    designateModule: function(id) {
        if (confirm("Embedding a module will change the name, code and type of the course. Are you sure you want to do this?")) {
            this.setState({designateLoad: true});
            CourseActions.designateModule(this.props.id, id);
        }
    },

    releaseModule: function() {
        this.setState({designateLoad: true});
        CourseActions.releaseModule(this.props.id);
    },

    _removeModule: function(id) {
        const moduleIndex = this.state.modules.findIndex((e)  => !!e && e.id === id);
        if (0 <= moduleIndex && !this.state.modules[moduleIndex].loading) {
            const modules = this.state.modules.map((m, i) => (i !== moduleIndex) ? m : ({...m, loading: true}));
            this.setState({modules, dialog: {}});
            CourseActions.deleteModule(this.props.id, id);
        }
        return true;
    },

    _onCourseAssetChange: function() {
        const assets  = CourseAssetStore.getByCourse(this.props.routeParams.id);
        if (assets !== undefined) {
            this.setState({assets: assets});
        }
    },

    _addAsset: function(asset) {
        if (!asset) { return false; }
        const index = this.state.assets.findIndex((e) => !!e && e.id == asset.id);
        if (0 > index) {
            asset.loading = true;
            delete asset.dateAdded;
            const assets = [
                ...this.state.assets,
                asset
            ];
            this.setState({assets});
            CourseActions.addAsset(this.props.routeParams.id, asset.id);
        }
        return true;

    },

    _openAddAssetDialog: function() {
        return this._openDialog('addAsset');
    },

    _onAssetAutocomplete: function(input) {
        clearTimeout(timeout);
        if (input !== undefined && input.length >= 2) {
            timeout = setTimeout(function() {
                AssetActions.search(input, {limit: 10});
                this.setState({searchString: input});
            }.bind(this), 500);
        }
    },

    _onAssetChange: function() {
        if (!this.state.searchString) { return; }
        const assets = AssetStore.search(this.state.searchString);
        if (assets !== undefined) {
            const assetList = assets.map(function(asset) {
                const click = this.onDialogSelect.bind(this, asset);

                const name = `${asset.name} (${asset.type})`;
                return {
                    text: asset.name,
                    value: <MenuItem key={asset.id} value={asset.id} primaryText={name} onTouchTap={click} />
                };
            }, this);
            this.setState({assetList: assetList});
        }
    },

    onLabelChange: function() {
        const labels = LabelStore.getAll();
        const labelList = labels.map((label) => ({
            text: label.name,
            value: <MenuItem key={label.id} value={label.id} primaryText={label.name} onTouchTap={() => this.onDialogSelect(label)}/>
        }));
        this.setState({labelList});
    },

    _openDialog: function(open) {
        const dialog = {
            ...this.state.dialog,
            open,
            value: null
        };
        this.setState({dialog});
    },

    openAddModuleDialog() {
        CourseActions.getCourseEnrolmentStats(this.props.id);
        this._openDialog('addModule');
    },

    closeDialog: function() {
        const dialog = {
            ...this.state.dialog,
            open: ''
        };
        this.setState({dialog});
    },

    onDialogSelect: function(element) {
        const dialog = {
            ...this.state.dialog,
            value: element
        };
        this.setState({dialog});
    },

    dialogSave: function() {
        var close = true;
        switch (this.state.dialog.open) {
            case 'addModule':
                close = this.addModule(this.state.dialog.value);
                break;
            case 'addAsset':
                close = this._addAsset(this.state.dialog.value);
                break;
            case 'addLabel':
                CourseActions.addLabel(this.props.routeParams.id, this.state.dialog.value);
                break;
            case 'removeModule':
                close = this._removeModule(this.state.dialog.value);
                break;
            default:
                console.error('unhandled dialog');
                close = false;
        }

        if (close) { this.closeDialog(); }
    },

    _onSave: function() {
        if (!!this.state.moduleData) {
            CourseActions.updateModules(this.props.id, { moduleData: this.state.moduleData });
        }
    },

    _onDelete: function(entityId) {
        if (entityId === this.props.id) {
            CourseActions.delete(entityId);
            window.location.href = this.state.links.list;
        }
    },


});

CourseSettings.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default withId(CourseSettings);
